<template>
  <b-modal
    :visible="visible"
    title="И-баримт дэлгэрэнгүй"
    size="lg"
    ok-only
    ok-title="Хаах"
    @hidden="$emit('update:visible', false)"
  >
    <div v-if="ebarimt">
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Дугаар:</b-col>
        <b-col cols="8">{{ ebarimt.bill_id_suffix }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Утасны дугаар:</b-col>
        <b-col cols="8">{{ ebarimt.username }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Сугалааны дугаар:</b-col>
        <b-col cols="8">{{ ebarimt.lottery }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Мөнгөн дүн:</b-col>
        <b-col cols="8">{{ formatCurrency(ebarimt.amount) }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">ДДТД:</b-col>
        <b-col cols="8">{{ ebarimt.ddtd }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Төлөв:</b-col>
        <b-col cols="8">
          <b-badge pill :variant="ebarimt.print_ebarimt ? 'light-success' : 'light-warning'">
            {{ ebarimt.print_ebarimt ? 'Хэвлэгдсэн' : 'Хэвлэгдээгүй' }}
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Илгээсэн огноо:</b-col>
        <b-col cols="8">{{ ebarimt.print_date }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Буцаагдсан эсэх:</b-col>
        <b-col cols="8">
          <b-badge pill :variant="ebarimt.is_returned ? 'light-danger' : 'light-success'">
            {{ ebarimt.is_returned ? 'Буцаагдсан' : 'Хэвийн' }}
          </b-badge>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol, BBadge } from 'bootstrap-vue'
import { formatCurrency } from '@core/utils/filter'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BBadge,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    ebarimt: {
      type: Object,
      default: null,
    },
  },
  setup() {
    return {
      formatCurrency,
    }
  },
}
</script>
